import Marionette from 'backbone.marionette';
import billListLayoutTmpl from '../templates/bill_list_layout.tpl';
export default Marionette.LayoutView.extend({
  template: billListLayoutTmpl,
  classname: "container",
  regions: {
    headlineRegion: "#headline",
    billListRegion: "#bill-list"
  }
});